<company-block-card [title]="'POA_TITLE_REQUIRED'" [explanationSubTitle]="powerOfAttorneyRulesTranslationKey" [isMarginBottom]="true">
  <!-- POA selection tip (sidebar mode only) -->
  <ng-container card-body *ngIf="canShowPoaVariantSelector">
    <div class="poa-selection-tip">
      <ng-container *ngIf="selectedPoaVariant === 'digital'">
        {{ "COMPANY.DIGITAL-SIGNATURE.POA_SELECTION_TIP_DIGITAL" | translate }}
      </ng-container>
      <ng-container *ngIf="selectedPoaVariant === 'manual'">
        {{ "COMPANY.DIGITAL-SIGNATURE.POA_SELECTION_TIP_MANUAL" | translate }}
      </ng-container>
      <ng-container *ngIf="!selectedPoaVariant && !digitalPoaDocument && !manualPoaDocument">
        {{ "COMPANY.DIGITAL-SIGNATURE.POA_SELECTION_TIP_NONE" | translate }}
      </ng-container>
    </div>
  </ng-container>

  <ng-container card-body>
    <company-sub-block-card [isShowFooter]="true">
      <!-- Digital signature banner (when no digital document yet, standard view) -->
      <ng-container inner-card-body *ngIf="isDigitalPoaAvailable && !digitalPoaDocument && !canShowPoaVariantSelector">
        <div class="digital-signature-banner d-flex justify-content-between align-items-center">
          <div class="digital-signature-banner__left">
            <div class="digital-signature-banner__header d-flex align-items-center">
              <span class="digital-signature-banner__title sign-title">{{ "COMPANY.DIGITAL-SIGNATURE.TITLE" | translate }}</span>
            </div>
            <ul class="signature-banner__list">
              <li>{{ "COMPANY.DIGITAL-SIGNATURE.ITEM_1" | translate }}</li>
              <li>{{ "COMPANY.DIGITAL-SIGNATURE.ITEM_2" | translate }}</li>
              <li *ngIf="isPoaPriceLoaded" [innerHTML]="'COMPANY.DIGITAL-SIGNATURE.ITEM_3' | translate : { price: poaPriceDisplay }"></li>
            </ul>
            <div class="digital-signature-banner__note">
              {{ "COMPANY.DIGITAL-SIGNATURE.NOTE" | translate }}
              <a [routerLink]="['/', 'contact-support']" target="_blank" class="link">
                {{ "COMPANY.DIGITAL-SIGNATURE.NOTE_LINK" | translate }}
              </a>
              .
            </div>
            <div class="digital-signature-banner__note">
              {{ "COMPANY.DIGITAL-SIGNATURE.APPROVAL_NOTE" | translate }}
            </div>
            <div class="digital-signature-banner__powered-by">
              <span>{{ "POWERED_BY" | translate }}</span>
              <img src="assets/images/docusign-logo.png" alt="DocuSign" width="100" />
            </div>
          </div>
          <div
            class="digital-signature-banner__right d-flex align-items-center"
            [class.flex-column]="shouldShowRequiredFieldsHint || isDigitalSignFailedToSend"
          >
            <button
              *ngIf="!isDigitalSignInProgress && !isDigitalPaymentPending"
              type="button"
              class="sign-btn"
              [class.sign-btn--disabled]="isDigitalSignButtonDisabled"
              [disabled]="isDigitalSignButtonDisabled"
              [title]="shouldShowRequiredFieldsHint ? (requiredFieldsHintTooltipKey | translate) : ''"
              (click)="onDigitalSignClick()"
            >
              <span>{{ "COMPANY.DIGITAL-SIGNATURE.BUTTON" | translate }}</span>
              <img class="sign-btn__icon" src="assets/icons/icon_arrow_right_white.svg" alt="" />
            </button>
            <div *ngIf="shouldShowRequiredFieldsHint" class="digital-signature-banner__hint">
              <ng-container *ngIf="!showIorProfileHintLink">{{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT" | translate }}</ng-container>
              <ng-container *ngIf="showIorProfileHintLink">
                {{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT_IOR_PROFILE" | translate }}
                <a class="link" [routerLink]="['/companies', 'account-settings', 'company-view', companyId]">
                  {{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT_IOR_PROFILE_LINK" | translate }}
                </a>
                .
              </ng-container>
            </div>
            <div *ngIf="isDigitalSignFailedToSend" class="digital-signature-banner__hint">
              {{ "COMPANY.DIGITAL-SIGNATURE.SERVICE_UNAVAILABLE_HINT" | translate }}
            </div>
            <ng-container *ngIf="isDigitalSignInProgress">
              <span class="digital-signature-banner__progress-badge">
                {{ "COMPANY.DIGITAL-SIGNATURE-IN-PROGRESS" | translate }}
              </span>
              <button
                *ngIf="canRemovePoa"
                type="button"
                class="digital-signature-banner__progress-cancel-btn"
                [disabled]="isDigitalSignLoading"
                (click)="openCancelDigitalPoaConfirm()"
                aria-label="Cancel digital signing"
              >
                <img src="assets/icons/icon_trash.svg" alt="cancel digital signing" />
              </button>
            </ng-container>
            <ng-container *ngIf="isDigitalPaymentPending">
              <span class="digital-signature-banner__progress-badge">
                {{ "YOUR_FILING_IS_ON_HOLD" | translate }}
              </span>
              <button
                *ngIf="canRemovePoa"
                type="button"
                class="digital-signature-banner__progress-cancel-btn"
                [disabled]="isDigitalSignLoading"
                (click)="openCancelDigitalPoaConfirm()"
                aria-label="Cancel digital signing"
              >
                <img src="assets/icons/icon_trash.svg" alt="cancel digital signing" />
              </button>
            </ng-container>
          </div>
          <div *ngIf="isInitialPoaLoading" class="manual-notary-block__overlay">
            <border-spinner
              *ngIf="isInitialPoaLoading"
              [centered]="true"
              loaderClass="sm-loader"
              aria-label="Loading power of attorney"
            ></border-spinner>
          </div>
        </div>
      </ng-container>

      <!-- Digital signature banner WITH radio button wrapper (sidebar mode, no digital doc) -->
      <ng-container inner-card-body *ngIf="isDigitalPoaAvailable && !digitalPoaDocument && canShowPoaVariantSelector">
        <div class="poa-document-wrapper mb-3" [title]="'COMPANY.DIGITAL-SIGNATURE.RADIO_DIGITAL_DISABLED_TOOLTIP' | translate">
          <app-radio-button
            classGroup="poa-document-radio"
            [control]="poaVariantControl"
            [id]="'poa-document-digital-banner'"
            [name]="'poa-document-selection'"
            [value]="'digital'"
            [label]="'COMPANY.DIGITAL-SIGNATURE.RADIO_DIGITAL'"
            [disabled]="isDigitalRadioDisabled"
          ></app-radio-button>
          <div class="poa-document-content">
            <div class="digital-signature-banner d-flex justify-content-between align-items-center">
              <div class="digital-signature-banner__left">
                <div class="digital-signature-banner__header d-flex align-items-center">
                  <span class="digital-signature-banner__title sign-title">{{ "COMPANY.DIGITAL-SIGNATURE.TITLE" | translate }}</span>
                </div>
                <ul class="signature-banner__list">
                  <li>{{ "COMPANY.DIGITAL-SIGNATURE.ITEM_1" | translate }}</li>
                  <li>{{ "COMPANY.DIGITAL-SIGNATURE.ITEM_2" | translate }}</li>
                  <li
                    *ngIf="isPoaPriceLoaded"
                    [innerHTML]="'COMPANY.DIGITAL-SIGNATURE.ITEM_3' | translate : { price: poaPriceDisplay }"
                  ></li>
                </ul>
                <div class="digital-signature-banner__note">
                  {{ "COMPANY.DIGITAL-SIGNATURE.NOTE" | translate }}
                  <a [routerLink]="['/', 'contact-support']" target="_blank" class="link">
                    {{ "COMPANY.DIGITAL-SIGNATURE.NOTE_LINK" | translate }}
                  </a>
                  .
                </div>
                <div class="digital-signature-banner__note">
                  {{ "COMPANY.DIGITAL-SIGNATURE.APPROVAL_NOTE" | translate }}
                </div>
                <div class="digital-signature-banner__powered-by">
                  <span>{{ "POWERED_BY" | translate }}</span>
                  <img src="assets/images/docusign-logo.png" alt="DocuSign" width="100" />
                </div>
              </div>
              <div
                class="digital-signature-banner__right d-flex align-items-center"
                [class.flex-column]="shouldShowRequiredFieldsHint || isDigitalSignFailedToSend"
              >
                <button
                  *ngIf="!isDigitalSignInProgress && !isDigitalPaymentPending"
                  type="button"
                  class="sign-btn"
                  [class.sign-btn--disabled]="isDigitalSignButtonDisabled"
                  [disabled]="isDigitalSignButtonDisabled"
                  [title]="shouldShowRequiredFieldsHint ? (requiredFieldsHintTooltipKey | translate) : ''"
                  (click)="onDigitalSignClick()"
                >
                  <span>{{ "COMPANY.DIGITAL-SIGNATURE.BUTTON" | translate }}</span>
                  <img class="sign-btn__icon" src="assets/icons/icon_arrow_right_white.svg" alt="" />
                </button>
                <div *ngIf="shouldShowRequiredFieldsHint" class="digital-signature-banner__hint">
                  <ng-container *ngIf="!showIorProfileHintLink">
                    {{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT" | translate }}
                  </ng-container>
                  <ng-container *ngIf="showIorProfileHintLink">
                    {{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT_IOR_PROFILE" | translate }}
                    <a class="link" [routerLink]="['/companies', 'account-settings', 'company-view', companyId]">
                      {{ "COMPANY.DIGITAL-SIGNATURE.FILL_REQUIRED_HINT_IOR_PROFILE_LINK" | translate }}
                    </a>
                    .
                  </ng-container>
                </div>
                <div *ngIf="isDigitalSignFailedToSend" class="digital-signature-banner__hint">
                  {{ "COMPANY.DIGITAL-SIGNATURE.SERVICE_UNAVAILABLE_HINT" | translate }}
                </div>
                <ng-container *ngIf="isDigitalSignInProgress">
                  <span class="digital-signature-banner__progress-badge">
                    {{ "COMPANY.DIGITAL-SIGNATURE-IN-PROGRESS" | translate }}
                  </span>
                  <button
                    *ngIf="canRemovePoa"
                    type="button"
                    class="digital-signature-banner__progress-cancel-btn"
                    [disabled]="isDigitalSignLoading"
                    (click)="openCancelDigitalPoaConfirm()"
                    aria-label="Cancel digital signing"
                  >
                    <img src="assets/icons/icon_trash.svg" alt="cancel digital signing" />
                  </button>
                </ng-container>
                <ng-container *ngIf="isDigitalPaymentPending">
                  <span class="digital-signature-banner__progress-badge">
                    {{ "YOUR_FILING_IS_ON_HOLD" | translate }}
                  </span>
                  <button
                    *ngIf="canRemovePoa"
                    type="button"
                    class="digital-signature-banner__progress-cancel-btn"
                    [disabled]="isDigitalSignLoading"
                    (click)="openCancelDigitalPoaConfirm()"
                    aria-label="Cancel digital signing"
                  >
                    <img src="assets/icons/icon_trash.svg" alt="cancel digital signing" />
                  </button>
                </ng-container>
              </div>
              <div *ngIf="isInitialPoaLoading" class="manual-notary-block__overlay">
                <border-spinner
                  *ngIf="isInitialPoaLoading"
                  [centered]="true"
                  loaderClass="sm-loader"
                  aria-label="Loading power of attorney"
                ></border-spinner>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Digital signed confirmation document (digital path) -->
      <ng-container inner-card-body *ngIf="isDigitalPoaAvailable && digitalPoaDocument">
        <div
          class="poa-document mb-3"
          [ngClass]="{
            'poa-document-wrapper': canShowPoaVariantSelector,
            'poa-document-wrapper--selected': canShowPoaVariantSelector && selectedPoaVariant === 'digital'
          }"
        >
          <ng-container *ngIf="canShowPoaVariantSelector">
            <app-radio-button
              classGroup="poa-document-radio"
              [control]="poaVariantControl"
              [id]="'poa-document-digital'"
              [name]="'poa-document-selection'"
              [value]="'digital'"
              [label]="'COMPANY.DIGITAL-SIGNATURE.RADIO_DIGITAL'"
            ></app-radio-button>
          </ng-container>
          <div class="poa-document-content">
            <div class="d-flex align-items-center">
              <div class="power-attorney-container__uploader pl-0 pr-0 col-12">
                <document-upload-desktop
                  [id]="'poa-company-digital-confirmation'"
                  [attachmentName]="'COMPANY.DIGITAL-SIGNATURE.CONFIRMATION'"
                  [uploadedDocument]="digitalPoaDocument"
                  [canUploadDocuments]="false"
                  [canRemoveDocuments]="canRemovePoa"
                  [canDownloadDocuments]="true"
                  [isLoading]="false"
                  [isShowOptionalTag]="false"
                  [isShowNormalAddIcon]="false"
                  [isStretched]="true"
                  [isDividedLayout]="true"
                  [isShowLoader]="false"
                  [isShowFooter]="false"
                  [isRequired]="false"
                  [isShowDownloadFile]="true"
                  [forceMobileView]="isCompactLayout"
                  (remove)="confirmCancelDigitalPoa = true"
                ></document-upload-desktop>
              </div>
            </div>
          </div>
        </div>

        <confirm-modal
          [isOpen]="confirmCancelDigitalPoa"
          [title]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_TITLE'"
          [description]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_BODY'"
          [acceptText]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_CONFIRM'"
          [declineText]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_DISCARD'"
          [acceptDisabled]="isDigitalSignLoading"
          [isAcceptLoading]="isDigitalSignLoading"
          (decline)="confirmCancelDigitalPoa = false"
          (accept)="onConfirmCancelDigitalPoa()"
        ></confirm-modal>
      </ng-container>

      <!-- Manual notary flow if no manual POA and no digital confirmation present (standard view) -->
      <ng-container inner-card-body *ngIf="isManualOnlyFlow && !manualPoaDocument && !isLoadingCompanyPoa && !canShowPoaVariantSelector">
        <div class="manual-notary-block d-flex">
          <div class="manual-notary-block__left flex-grow-1">
            <div class="manual-notary-block__title sign-title">{{ "COMPANY.MANUAL-SIGNATURE.TITLE" | translate }}</div>
            <ul class="signature-banner__list">
              <li>{{ "COMPANY.MANUAL-SIGNATURE.ITEM_1" | translate }}</li>
              <li>{{ "COMPANY.MANUAL-SIGNATURE.ITEM_2" | translate }}</li>
            </ul>
            <div class="manual-notary-block__note" [innerHTML]="'COMPANY.POWER_OF_ATTORNEY_DESCRIPTION' | translate"></div>
          </div>
          <div class="manual-notary-block__right d-flex flex-column align-items-center justify-content-center">
            <a class="sign-btn sign-btn--outline manual-notary-block__btn" [href]="poaFileUrl" target="_blank" download>
              <span class="d-inline-flex align-items-center">
                <span class="manual-notary-block__download-icon"><icon-download></icon-download></span>
                <span>{{ "COMPANY.MANUAL-SIGNATURE.DOWNLOAD" | translate }}</span>
              </span>
            </a>
            <button type="button" class="sign-btn manual-notary-block__btn" (click)="manualPoaInput.click()">
              <span>{{ "COMPANY.MANUAL-SIGNATURE.UPLOAD" | translate }}</span>
            </button>
            <input #manualPoaInput type="file" hidden (change)="onManualPoaUpload($event, manualPoaInput)" />
          </div>
          <div *ngIf="isInitialPoaLoading || shouldBlockManualPoa" class="manual-notary-block__overlay">
            <border-spinner
              *ngIf="isInitialPoaLoading"
              [centered]="true"
              loaderClass="sm-loader"
              aria-label="Loading power of attorney"
            ></border-spinner>
          </div>
        </div>
      </ng-container>

      <!-- Manual notary block WITH radio button wrapper (sidebar mode, no manual doc) -->
      <ng-container inner-card-body *ngIf="isManualOnlyFlow && !manualPoaDocument && !isLoadingCompanyPoa && canShowPoaVariantSelector">
        <div class="poa-document-wrapper mb-3" [title]="'COMPANY.DIGITAL-SIGNATURE.RADIO_MANUAL_DISABLED_TOOLTIP' | translate">
          <app-radio-button
            classGroup="poa-document-radio"
            [control]="poaVariantControl"
            [id]="'poa-document-manual-block'"
            [name]="'poa-document-selection'"
            [value]="'manual'"
            [label]="'COMPANY.DIGITAL-SIGNATURE.RADIO_MANUAL'"
            [disabled]="isManualRadioDisabled"
          ></app-radio-button>
          <div class="poa-document-content">
            <div class="manual-notary-block d-flex">
              <div class="manual-notary-block__left flex-grow-1">
                <div class="manual-notary-block__title sign-title">{{ "COMPANY.MANUAL-SIGNATURE.TITLE" | translate }}</div>
                <ul class="signature-banner__list">
                  <li>{{ "COMPANY.MANUAL-SIGNATURE.ITEM_1" | translate }}</li>
                  <li>{{ "COMPANY.MANUAL-SIGNATURE.ITEM_2" | translate }}</li>
                </ul>
                <div class="manual-notary-block__note" [innerHTML]="'COMPANY.POWER_OF_ATTORNEY_DESCRIPTION' | translate"></div>
              </div>
              <div class="manual-notary-block__right d-flex flex-column align-items-center justify-content-center">
                <a class="sign-btn sign-btn--outline manual-notary-block__btn" [href]="poaFileUrl" target="_blank" download>
                  <span class="d-inline-flex align-items-center">
                    <span class="manual-notary-block__download-icon"><icon-download></icon-download></span>
                    <span>{{ "COMPANY.MANUAL-SIGNATURE.DOWNLOAD" | translate }}</span>
                  </span>
                </a>
                <button type="button" class="sign-btn manual-notary-block__btn" (click)="manualPoaInputSidebar.click()">
                  <span>{{ "COMPANY.MANUAL-SIGNATURE.UPLOAD" | translate }}</span>
                </button>
                <input #manualPoaInputSidebar type="file" hidden (change)="onManualPoaUpload($event, manualPoaInputSidebar)" />
              </div>
              <div *ngIf="isInitialPoaLoading || shouldBlockManualPoa" class="manual-notary-block__overlay">
                <border-spinner
                  *ngIf="isInitialPoaLoading"
                  [centered]="true"
                  loaderClass="sm-loader"
                  aria-label="Loading power of attorney"
                ></border-spinner>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Manual POA existing or uploading (includes legacy documents for digital-only companies) -->
      <ng-container inner-card-body *ngIf="shouldShowManualPoaSection">
        <div
          class="poa-document mb-3"
          [ngClass]="{
            'poa-document-wrapper': canShowPoaVariantSelector,
            'poa-document-wrapper--selected': canShowPoaVariantSelector && selectedPoaVariant === 'manual'
          }"
        >
          <ng-container *ngIf="canShowPoaVariantSelector">
            <app-radio-button
              classGroup="poa-document-radio"
              [control]="poaVariantControl"
              [id]="'poa-document-manual'"
              [name]="'poa-document-selection'"
              [value]="'manual'"
              [label]="'COMPANY.DIGITAL-SIGNATURE.RADIO_MANUAL'"
            ></app-radio-button>
          </ng-container>
          <div class="poa-document-content">
            <div class="d-flex align-items-center">
              <div class="power-attorney-container__uploader pl-0 pr-0 col-12">
                <document-upload-desktop
                  [id]="'poa-company'"
                  [attachmentName]="'DOCUMENT_TYPE.POWER_OF_ATTORNEY_MANUAL'"
                  [attachmentHint]="'COMPANY.POWER_OF_ATTORNEY_DESC'"
                  [uploadedDocument]="manualPoaDocument"
                  [canUploadDocuments]="false"
                  [canRemoveDocuments]="canRemovePoa"
                  [canDownloadDocuments]="true"
                  [isLoading]="isLoadingCompanyPoa"
                  [isShowOptionalTag]="false"
                  [isShowNormalAddIcon]="false"
                  [isStretched]="true"
                  [isDividedLayout]="true"
                  [isShowLoader]="true"
                  [isShowFooter]="false"
                  [isRequired]="true"
                  [forceMobileView]="isCompactLayout"
                  (remove)="deleteDocument.emit($event)"
                  (stateUpdate)="onManualPoaStateUpdate($event)"
                ></document-upload-desktop>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </company-sub-block-card>
  </ng-container>
</company-block-card>

<confirm-modal
  [isOpen]="confirmCancelDigitalPoa"
  [title]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_TITLE'"
  [description]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_BODY'"
  [acceptText]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_CONFIRM'"
  [declineText]="'COMPANY.DIGITAL-SIGNATURE.CANCEL_DISCARD'"
  [acceptDisabled]="isDigitalSignLoading"
  [isAcceptLoading]="isDigitalSignLoading"
  (decline)="confirmCancelDigitalPoa = false"
  (accept)="onConfirmCancelDigitalPoa()"
></confirm-modal>
